import React, {Suspense} from 'react';

import {Route, BrowserRouter as Router} from 'react-router-dom';

import isPropValid from '@emotion/is-prop-valid';
import {StyleSheetManager} from 'styled-components';
import {QueryParamProvider} from 'use-query-params';

import {Spinner} from 'components';
import {withAuthenticator} from 'components/Auth';
import {lazyWithPreload} from 'lib/utils';

const LazyApp = lazyWithPreload(async () => {
  const module = await import('./App');
  return {default: module.default};
});

const App = withAuthenticator(LazyApp);

// This configuration resolves styled-components v6 prop forwarding warnings.
// It mimics v5 behavior: forwards only valid HTML attributes to DOM elements,
// but forwards all props to React components.
const shouldForwardProp = (propName: string, target: string | React.ComponentType) => {
  if (typeof target === 'string') {
    // For HTML elements, only forward valid HTML attributes
    return isPropValid(propName);
  }
  // For components, forward all props
  return true;
};

const Root = (): React.JSX.Element => {
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <Suspense fallback={<Spinner />}>
        <Router>
          <QueryParamProvider ReactRouterRoute={Route}>
            <App />
          </QueryParamProvider>
        </Router>
      </Suspense>
    </StyleSheetManager>
  );
};

export default Root;
